export default "__VITE_ASSET__dS3mrU5Z__"